import { API } from './api';
import { GW_SERVICES_PREFIXES } from '../constants/gateway';

const { INTERNAL } = GW_SERVICES_PREFIXES;

export const GetPayments = (params: any) =>
  API.get(`/${INTERNAL}/api/v4/cabinet/payments/`, params);

export const DownloadReceipt = (docId: string) =>
  API.get(`/${INTERNAL}/api/v4/cash/online/receipt/${docId}/`);